import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { token } = useSelector((state: any) => state.auth);

  return token ? children || <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
